module.exports = __webpack_public_path__ + "static/media/sleepnix-5.60e26b4b.jpg";